<template>
  <draggable
    v-model="treeLayer"
    class="full-height"
    ghostClass="ghost"
    :group="{
      name: 'layers',
      pull: true,
      put: true,
    }"
    handle=".draggable-handle"
    @choose="onChooseGroupItem"
    @end="onEnd()"
    style="padding: 2px"
  >
    <template v-for="(layerGroup, index) in treeLayer">
      <DraggableListItem
        :disabledDrag="disabledDrag"
        v-if="layerGroup.isGroup"
        :key="layerGroup.id + '_' + index"
        class="mb-3"
        :readonly="readonly"
      >
        <div class="d-flex justify-center align-center">
          <template v-if="isGroupEdit[layerGroup.id]">
            <v-text-field
              v-model="layerGroup.name"
              dense
              hide-details
              placeholder="Tên nhóm"
              @keydown.enter.prevent="saveGroup(layerGroup.id)"
            >
              <template v-slot:append-outer>
                <v-icon small @click="saveGroup(layerGroup.id)">
                  mdi-content-save
                </v-icon>
              </template>
            </v-text-field>
          </template>
          <template v-else>
            <span
              class="d-inline-block text-truncate text-left flex-grow-1"
              :title="layerGroup.name"
            >
              {{ layerGroup.name }}</span
            >
            <div class="flex-grow-0 d-flex">
              <slot :group="layerGroup" name="extra-btn-item-group"></slot>
              <template v-if="!layerGroup.disableEdit">
                <base-button
                  icon
                  small
                  v-if="!readonly"
                  tooltip="Đổi tên nhóm"
                  @click="editGroup(layerGroup.id)"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </base-button>
                <base-button
                  icon
                  small
                  tooltip="Bỏ nhóm"
                  v-if="!readonly"
                  @click="unGroup(layerGroup, index)"
                >
                  <v-icon small>mdi-ungroup</v-icon>
                </base-button>
              </template>
              <base-button
                icon
                small
                :tooltip="isGroupShow[layerGroup.id] ? 'Đóng' : 'Mở'"
                @click="toggleShowGroup(layerGroup.id)"
              >
                <v-icon>
                  {{
                    isGroupShow[layerGroup.id]
                      ? 'mdi-chevron-up'
                      : 'mdi-chevron-down'
                  }}
                </v-icon>
              </base-button>

              <base-button
                icon
                small
                v-if="!readonly"
                tooltip="Xoá nhóm"
                @click="deleteGroup(layerGroup, index)"
              >
                <v-icon small>mdi-delete</v-icon>
              </base-button>
            </div>
          </template>
        </div>
        <v-divider v-if="isGroupShow[layerGroup.id]" class="py-1"></v-divider>
        <draggable
          v-show="isGroupShow[layerGroup.id]"
          v-model="layerGroup.children"
          ghostClass="ghost"
          :group="{
            name: 'layers',
            pull: true,
            put: checkItemCanPutInChildren,
          }"
          handle=".draggable-handle"
          :style="c_style"
          @end="onEnd()"
        >
          <div
            v-for="(element, element_index) in layerGroup.children"
            :key="element.id + '_' + index + '_' + element_index"
            class="mb-3"
          >
            <DraggableListItem
              :disabledDrag="disabledDrag"
              :isSelected="currentSelectId.includes(layerGroup.id)"
              :item="element"
              :readonly="readonly"
            >
              <slot
                :group="layerGroup"
                :isSelected="currentSelectId.includes(element.id)"
                :item="element"
                name="item"
                :toggleSelect="toggleSelect"
              ></slot>
            </DraggableListItem>
          </div>
        </draggable>
      </DraggableListItem>
      <div v-else :key="layerGroup.id + '_else_' + index" class="mb-3">
        <DraggableListItem
          :disabledDrag="disabledDrag"
          :isSelected="currentSelectId.includes(layerGroup.id)"
          :item="layerGroup"
          :readonly="readonly"
        >
          <slot
            :isSelected="currentSelectId.includes(layerGroup.id)"
            :item="layerGroup"
            :index="index"
            name="item"
            :toggleSelect="toggleSelect"
          ></slot>
        </DraggableListItem>
      </div>
    </template>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

import DraggableListItem from './draggable-list-item.vue'
export default {
  components: { draggable, DraggableListItem },
  props: {
    items: { type: Array, required: true },
    selected: { type: Array, default: () => [] },
    groupShow: { type: Object, default: () => ({}) },
    disabledSelect: Boolean,
    disabledDrag: Boolean,
    readonly: Boolean,
  },
  data: () => ({
    treeLayer: [],
    isGroupEdit: {},
    currentSelectLayerObject: {},
    currentItemDrag: undefined,
  }),
  watch: {
    items: {
      handler(value) {
        this.treeLayer = value || []
      },
      immediate: true,
    },
  },
  created() {},
  computed: {
    c_style() {
      let style = {}
      if (!this.readonly) style.minHeight = '80px'

      return style
    },
    currentSelectId: {
      get() {
        return this.selected
      },
      set(value) {
        this.$emit('update:selected', value)
      },
    },
    isGroupShow: {
      get() {
        return this.groupShow
      },
      set(value) {
        this.$emit('update:groupShow', value)
      },
    },
  },
  methods: {
    removeSelect(layer) {
      if (this.currentSelectId.includes(layer.id)) {
        this.currentSelectId = this.currentSelectId.filter((x) => x != layer.id)
      }
    },
    toggleSelect(layer) {
      if (this.disabledSelect) return
      if (this.readonly) return
      if (this.currentSelectId.includes(layer.id)) {
        this.currentSelectId = this.currentSelectId.filter((x) => x != layer.id)
      } else {
        this.currentSelectId.push(layer.id)
        this.currentSelectLayerObject[layer.id] = layer
      }
    },
    editGroup(groupId) {
      this.isGroupEdit[groupId] = true
      this.$forceUpdate()
    },
    saveGroup(groupId) {
      this.isGroupEdit[groupId] = false
      this.$forceUpdate()
    },
    toggleShowGroup(groupId) {
      this.isGroupShow[groupId] = !this.isGroupShow[groupId]
      this.$forceUpdate()
    },
    addSelectToNewGroup() {
      let indexAdd = this.treeLayer.findIndex((x) =>
        this.currentSelectId.includes(x.id)
      )
      indexAdd = indexAdd >= 0 ? indexAdd : 0
      //remove layer from old
      this.treeLayer = this.treeLayer
        .filter((layerGroup) => !this.currentSelectId.includes(layerGroup.id))
        .map((layerGroup) => {
          if (layerGroup.isGroup) {
            layerGroup.children = layerGroup.children.filter(
              (layer) => !this.currentSelectId.includes(layer.id)
            )
          }
          return layerGroup
        })
      // add select item to group
      let children = this.currentSelectId.map(
        (x) => this.currentSelectLayerObject[x]
      )
      let group = {
        id: `group-${new Date().getTime()}`,
        name: 'Nhóm',
        isGroup: true,
        children,
      }
      this.treeLayer.splice(indexAdd, 0, group)
      this.isGroupShow[group.id] = true
      this.currentSelectId = []
      this.currentSelectLayerObject = {}
      if (group.children.length > 0) this.onEnd()
    },
    addNewGroup(children = []) {
      let group = {
        id: `group-${new Date().getTime()}`,
        name: 'New Group',
        isGroup: true,
        children,
      }
      this.treeLayer.unshift(group)
      this.isGroupShow[group.id] = true
    },
    unGroup(group, groupIndex) {
      this.treeLayer.splice(groupIndex, 1)
      if (group.children.length > 0) {
        this.treeLayer.splice(groupIndex, 0, ...group.children)
      }
    },
    onChooseGroupItem(e) {
      this.currentItemDrag = this.treeLayer[e.oldIndex]
    },
    onEnd() {
      this.currentItemDrag = undefined
      this.$emit('update:items', this.treeLayer)
      setTimeout(() => {
        this.$emit('click:drag-done')
      }, 0)
    },
    checkItemCanPutInChildren(e) {
      // only 2 lever, group can't drag to other group
      return !(this.currentItemDrag && this.currentItemDrag.isGroup)
    },
    deleteGroup(group, groupIndex) {
      this.treeLayer.splice(groupIndex, 1)
      this.$emit('click:remove-group', group)
    },
  },
}
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}
:deep(.no-move) {
  transition: transform 0s;
}
:deep(.ghost) {
  opacity: 0.5;
  background: #c8ebfb;
}
.draggable-handle {
  cursor: all-scroll;
}
</style>
